import { render } from "./GameDepots.vue?vue&type=template&id=3267ae6c&scoped=true"
import script from "./GameDepots.vue?vue&type=script&lang=js"
export * from "./GameDepots.vue?vue&type=script&lang=js"

import "./GameDepots.vue?vue&type=style&index=0&id=3267ae6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3267ae6c"]])

export default __exports__